import React, { useEffect, useState } from "react";
import { db } from "../firebase-config";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./EmployeeListPage.css";

function EmployeeListPage() {
  const [employees, setEmployees] = useState([]);
  const [sites, setSites] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEmployees();
    fetchSites();
  }, []);

  const fetchEmployees = async () => {
    const querySnapshot = await getDocs(collection(db, "employees"));
    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setEmployees(list);
  };

  const fetchSites = async () => {
    const querySnapshot = await getDocs(collection(db, "sites"));
    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setSites(list);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Supprimer ce salarié ?")) {
      await deleteDoc(doc(db, "employees", id));
      fetchEmployees();
    }
  };

  const handleCreate = () => {
    navigate("/admin/create-employee");
  };

  const getSiteNames = (siteDeTravail) => {
    if (!siteDeTravail) return "Non défini";

    const siteIds = Array.isArray(siteDeTravail) ? siteDeTravail : [siteDeTravail];

    const siteNames = siteIds.map((siteId) => {
      const site = sites.find((s) => s.id === siteId);
      return site ? site.nom : "Inconnu";
    });

    return siteNames.join(", ");
  };

  return (
    <div className="employee-list-page">
      <button className="admin-button" onClick={() => navigate("/admin")}>
        🏠 Espace Admin
      </button>
      <h1>Liste des salariés</h1>
      <button className="create-button" onClick={handleCreate}>
        ➕ Créer un salarié
      </button>

      <table className="employee-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Email</th>
            <th>Entreprise</th>
            <th>Site(s) de travail</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((emp) => (
            <tr key={emp.id}>
              <td>{emp.nom}</td>
              <td>{emp.prenom}</td>
              <td>{emp.email}</td>
              <td>{emp.entreprise || ''}</td>
              <td>{getSiteNames(emp.siteDeTravail)}</td>
              <td>
                <button onClick={() => navigate(`/admin/edit-employee/${emp.id}`)}>✏️</button>
                <button onClick={() => handleDelete(emp.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default EmployeeListPage;
